import { DateTime } from 'luxon'
import { create } from 'zustand'

type AppError = {
    status?: number
    message: string
    time: string
}

type ErrorStore = {
    errors: AppError[]
    addError: (error: { status?: number; message: string }) => void
}

export const useErrorStore = create<ErrorStore>((set) => ({
    errors: [],
    addError: (error) =>
        set((state) => ({
            errors: [
                ...state.errors,
                {
                    status: error.status,
                    message: error.message,
                    time: DateTime.now().toISO(),
                },
            ],
        })),
}))
